import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../client';
import type { WorkerStatus } from 'markcat-domain';

interface ProcessingStatusOptions {
  enabled?: boolean;
  refetchInterval?: number | false;
}

export function useProcessingStatus(options?: ProcessingStatusOptions) {
  return useQuery({
    queryKey: ['processing-status'],
    queryFn: () => apiFetch<WorkerStatus>('/api/processing/status'),
    enabled: options?.enabled ?? true,
    refetchInterval: options?.refetchInterval ?? 5_000,
  });
}
